<template>
  <div class="container login">
    <div class="row">
      <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
        <div class="logo">
          <img src="@/csmworkflow/img/logo.svg"/>
        </div>
        <div class="card card-signin my-5">
          <div class="card-body">
            <h5 class="card-title text-center">Sign In</h5>
            <div class="alert alert-danger" v-show="error">{{ error }}</div>
            <form @submit.prevent="login" class="form-signin">
              <div class="form-label-group">
                <input
                  type="email"
                  id="inputEmail"
                  class="form-control"
                  v-model="email"
                  placeholder="Email address"
                  required
                  autofocus
                />
                <label for="inputEmail">Email address</label>
              </div>

              <div class="form-label-group">
                <input
                  type="password"
                  id="inputPassword"
                  class="form-control"
                  v-model="password"
                  placeholder="Password"
                  required
                />
                <label for="inputPassword">Password</label>
              </div>
              <button class="btn btn-lg btn-primary btn-block text-uppercase" type="submit">Sign in</button>
              <hr />
              <router-link
                class="btn btn-lg btn-text btn-block text-uppercase"
                to="/forgot-password"
              >Forgot Password?</router-link>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      error: false
    };
  },
  methods: {
    login() {
      let email = this.email,
        password = this.password;
      this.$store
        .dispatch("login", { email, password })
        .then(() => {
          if(this.$route.query.redirect) {
            this.$router.replace(this.$route.query.redirect);
          } else {
            this.$router.push('/my-week');
          }
          
        })
        .catch(err => {
          this.error = "Incorrect username or password.";
        });
    }
  }
};
</script>